document.addEventListener('DOMContentLoaded', function() {
  // Select the first checkout button by ID
  const checkoutButton1 = document.querySelector('#checkout');  // First checkout button
  // Select the second checkout button by class
  const checkoutButton2 = document.querySelector('.button--primary.button--full-width'); // Second checkout button

  // If either of the checkout buttons isn't found, log an error for debugging
  if (!checkoutButton1 && !checkoutButton2) {
    console.error('No checkout buttons found!');
    return;
  }

  // Create the popup element dynamically
  const popup = document.createElement('div');
  const overlay = document.createElement('div');

  popup.innerHTML = `
    <div style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0, 0, 0, 0.5); z-index: 9999;">
      <div style="position: relative; margin: 100px auto; background: #fff; padding: 20px; max-width: 400px;">
        <h2>Please provide the following information</h2>
        <form id="custom-form">
          <label for="fundraising_org">Fundraising Organization:</label>
          <input type="text" id="fundraising_org" name="attributes[Fundraising Organization]" required>
          <label for="seller_name">Person you are supporting's First and Last Name:</label>
          <input type="text" id="seller_name" name="attributes[Seller’s Name]" required>
          <label for="additional_info">Any additional information:</label>
          <textarea id="additional_info" name="attributes[Additional Information]"></textarea>
          <button type="submit">Submit and Checkout</button>
        </form>
        <button id="close-popup" style="position: absolute; top: 10px; right: 10px;">X</button>
      </div>
    </div>
  `;

  // Append the popup and overlay to the body, but keep it hidden initially
  document.body.appendChild(overlay);
  document.body.appendChild(popup);

  popup.style.display = 'none'; // Ensure it's hidden initially
  overlay.style.display = 'none'; // Ensure overlay is hidden too

  // Show the popup when the first checkout button is clicked
  if (checkoutButton1) {
    checkoutButton1.addEventListener('click', function(e) {
      e.preventDefault(); // Prevent the default checkout action

      // Show the popup and overlay
      popup.style.display = 'block';
      overlay.style.display = 'block';
    });
  }

  // Show the popup when the second checkout button is clicked
  if (checkoutButton2) {
    checkoutButton2.addEventListener('click', function(e) {
      e.preventDefault(); // Prevent the default checkout action

      // Show the popup and overlay
      popup.style.display = 'block';
      overlay.style.display = 'block';
    });
  }

  // Close the popup when the close button is clicked
  document.getElementById('close-popup').addEventListener('click', function() {
    popup.style.display = 'none';
    overlay.style.display = 'none';
  });

  // Handle form submission
  document.getElementById('custom-form').addEventListener('submit', function(e) {
    e.preventDefault(); // Prevent form submission

    // Collect the form data
    const org = document.getElementById('fundraising_org').value;
    const seller = document.getElementById('seller_name').value;
    const additionalInfo = document.getElementById('additional_info').value;

    // Update cart with the collected data as attributes
    fetch('/cart/update.js', {
      method: 'POST',
      body: JSON.stringify({
        attributes: {
          "Fundraising Organization": org,
          "Seller’s Name": seller,
          "Additional Information": additionalInfo
        }
      }),
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then(response => response.json())
    .then(data => {
      // After submitting, redirect to the checkout page
      window.location.href = '/checkout';
    })
    .catch(err => console.error('Error updating cart attributes:', err));
  });
});
